import { createAsyncReducer } from '../../standard-actions';
import {
    IAdaptiveMobilityPlanAction,
    IAdaptiveMobilityPlanSuccessAction,
    IAdaptiveMobilityPlanErrorAction
} from '../actions/load-adaptive-mobility-plan';
import { IServiceRequestsState } from '../state';
import { initialState } from '../state/initial-state';

export type LoadAdaptiveMobilityPlanDetailAction
    = IAdaptiveMobilityPlanAction
    | IAdaptiveMobilityPlanSuccessAction
    | IAdaptiveMobilityPlanErrorAction;

const init = (state: IServiceRequestsState, action: LoadAdaptiveMobilityPlanDetailAction) => ({
    ...state,
    adaptiveMobilityPlanDetails: {
        ...initialState.adaptiveMobilityPlanDetails,
        status: action.status
    }
});

const success = (state: IServiceRequestsState, action: LoadAdaptiveMobilityPlanDetailAction) => ({
    ...state,
    adaptiveMobilityPlanDetails: {
        ...initialState.adaptiveMobilityPlanDetails,
        status: action.status,
        data: (action as IAdaptiveMobilityPlanSuccessAction).data
    }
});

const failure = (state: IServiceRequestsState, action: LoadAdaptiveMobilityPlanDetailAction) => ({
    ...state,
    adaptiveMobilityPlanDetails: {
        ...initialState.adaptiveMobilityPlanDetails,
        status: action.status,
        error: (action as IAdaptiveMobilityPlanErrorAction).error
    }
});

export const loadAdaptiveMobilityPlanDetailReducer = createAsyncReducer(initialState, init, success, failure);
